module.exports = {
  common: {
    yeardate_label: 'Millésime {year}',
    metal: {
      silver: 'argent',
      gold: 'or',
    },
    devise: 'euros',
    reminder: {
      cta: 'Créer un rappel',
      title: 'Ajouter à mon agenda',
      text: 'Ajoutez la date de lancement de la monnaie, pour être prévenu de sa sortie.',
      event: {
        title: 'Lancement monnaie {value} euros en {metal} "{collection}"',
        description: 'Réservez votre monnaie de {value} euros en {metal} pur "{collection}". Rendez-vous sur {link}',
        location: '2 bis, rue Guénégaud, 75006 Paris',
      },
    },
    timer: {
      days: 'Jours',
      hours: 'Heures',
      minutes: 'Minutes',
    },
    subscription: '<strong>{days}</strong>jours à<em>{value}€</em>',
    legals: 'pour acquérir votre monnaie à sa valeur faciale.',
    faq: {
      title: '<b>« Le Génie Français »,</b> de précieuses valeurs à transmettre.',
      cta: 'Pourquoi acheter\nune monnaie à valeur faciale ?',
      items: [
        {
          question: 'Une véritable monnaie',
          answer: 'Ces objets de collection sont d\'abord et avant tout de véritables monnaies qui ont cours légal en France. Elles pourront être échangées à tout moment à la Banque de France.',
        },
        {
          question: 'Une épargne sûre',
          answer: 'Ces monnaies frappées en édition limitée vaudront toujours, au minimum, leur valeur faciale, et pourront également prendre de la valeur au fil du temps. Ces monnaies rassemblent toutes les caractéristiques propices à une diversification d’épargne sûre et judicieuse.',
        },
        {
          question: 'Un cadeau d\'exception',
          answer: 'Ces monnaies témoignent du savoir-faire inimitable et millénaire des artisans de la Monnaie de Paris. Le grand soin apporté à chaque détail saura ravir les collectionneurs, désireux d’acquérir un véritable objet d’art et de se constituer un précieux patrimoine à préserver ou à transmettre.',
        },
      ],
      back: 'Retour aux collections',
    },
  },

  home: {
    h2: 'Trilogie Le Génie Français',
    liberty: {
      claim: 'Offrez le Génie de la Liberté, premier millésime de la trilogie Génie Français. Représenté nu avec des ailes d\'ange, le Génie est une allégorie de la Libération. De sa main droite, il brandit fièrement une torche, symbole de la lumière qui guidera le peuple, tandis que sa main gauche s\'empare d\'une chaîne brisée.',
    },
    equality: {
      claim: 'Offrez le Génie de la Constitution, second millésime de la trilogie « Le Génie Français ».  Cette monnaie symbolise l\'Égalité entre tous, valeur fondamentale de notre République.',
    },
    fraternity: {
      claim: 'Offrez le Génie de la fraternité, dernière monnaie de la trilogie « le Génie Français ». Ce millésime met à l\'honneur la Fraternité à travers un Génie armé. Grâce à son épée et son bouclier, il protège le peuple et défend les liens qui unissent tous les Français.',
    },
    h4: 'Les monnaies',
    nav: 'La trilogie le Génie Français',
  },
  teaser: {
    liberty: '',
    equality: 'En 2027, la trilogie célébrera le Génie de la Constitution, œuvre emblématique du graveur Augustin Dupré, déjà présent sur des monnaies historiques et de collection. Ce symbole, qui grave la Constitution française, incarne la valeur d’Égalité en droit de la devise française.',
    fraternity: 'L’année 2028 marquera la clôture de cette trilogie avec la frappe, pour la première fois, d’un Génie inédit d’Augustin Dupré. Interprété par la Monnaie de Paris ce Génie, symbole de Fraternité, sera frappé pour la première fois sur une monnaie.',
  },
  product: {
    navTitle: 'Les autres monnaies',
    available_in: 'Rendez-vous en {year}',
    legal: 'Compte tenu de la forte volatilité du cours des métaux précieux, la commercialisation du produit pourrait être suspendue si la valeur métal venait à dépasser le prix de vente. Les tarifs applicables pourraient être modifiés à la hausse sans préavis.',
  },
  history: {
    cta: 'En savoir plus sur\nla trilogie du Génie Français',
    title: 'Découvrez les origines et les inspirations de notre nouvelle collection.',
  },
};
